export const PIXEL_RATIO: number = /Mobi|iPad/i.test(navigator.userAgent) ? 2 : 1
export const VIEWPORT_RATIO: number = 0.9
